import { useEffect, useState, useRef } from "react"
import PlayIcon from '@material-ui/icons/PlayCircleFilled';
import PauseIcon from '@material-ui/icons/PauseCircleFilled';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { CircularProgress, Grid, Slider, Typography } from "@material-ui/core";
import { getDownloadUrl } from "service/api";


export default function CallRecordingPlayer({
    audioKey
}) {
    const [audioUrl, setAudioUrl] = useState(null);
    const [isLoadingAudioUrl, setIsLoadingAudioUrl] = useState(true);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [downloadStarted, setDownloadStarted] = useState(false);
    const audioRef = useRef(null);
    const togglePlay = () => {
        if (audioRef.current && !hasError && !isLoading) {
            if (isPlaying) {
                audioRef.current.pause();
            } else {
                audioRef.current.play().catch((error) => {
                    console.error('Playback failed:', error);
                    setHasError(true);
                });
            }
            setIsPlaying(!isPlaying);
        }
    };
    const handleTimeUpdate = () => {
        if (audioRef.current) {
            setCurrentTime(audioRef.current.currentTime);
        }
    };
    const handleLoadedMetadata = () => {
        if (audioRef.current) {
            const audioDuration = audioRef.current.duration;
            // Use the detected duration if valid, otherwise keep the provided audioLength
            if (isFinite(audioDuration) && !isNaN(audioDuration)) {
                setDuration(audioDuration);
            }
            setIsLoading(false);
        }
    };
    const handleCanPlay = () => {
        setIsLoading(false);
    };
    const handleError = (e) => {
        setHasError(true);
        setIsLoading(false);
        setIsPlaying(false);
    };
    const handleSeek = (event, time) => {
        if (audioRef.current && !hasError) {
            audioRef.current.currentTime = time;
            setCurrentTime(time);
        }
    };
    const formatTime = (time) => {
        if (!isFinite(time) || isNaN(time)) {
            return '--:--';
        }
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    };
    const handleEnded = () => {
        setIsPlaying(false);
        setCurrentTime(0);
    };
    const handleDownload = async () => {
        if (!hasError && audioUrl.mp3) {
            try {
                setDownloadStarted(true);
                // await sleep(500);
                const response = await fetch(audioUrl.mp3);
                const blob = await response.blob();

                // Create object URL for the blob
                const blobUrl = URL.createObjectURL(blob);

                // Create download link
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = `${audioKey}.mp3`; // Include file extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Clean up the blob URL
                URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.error('Download failed:', error);
            } finally {
                setDownloadStarted(false);
            }
        }
    };
    const fetchAudioUrl = async () => {
        setAudioUrl(null);
        setIsLoadingAudioUrl(true);
        getDownloadUrl((data) => {
            if (data?.downloadUrl) {
                setAudioUrl({
                    mp3: data.downloadUrl,
                    wav: data.downloadUrl.replace(".mp3", ".wav")
                });
                setIsLoadingAudioUrl(false);
            }
        }, (poshError, status, content) => {
            console.error('Error Fetching audio url', poshError, status, content);
            setAudioUrl(null);
            setIsLoadingAudioUrl(false);
        }, audioKey)
    }
    useEffect(() => {
        fetchAudioUrl()
    }, [])
    if (isLoadingAudioUrl) {
        return <Grid style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 20
        }}>
            <CircularProgress style={{ color: '#B61256', }} />
        </Grid>
    }
    if (!audioUrl?.wav && !audioUrl?.mp3) {
        return null;
    }
    return (<Grid style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 20 }}>
        <audio
            style={{ width: '500px' }}
            ref={audioRef}
            src={audioUrl?.wav ?? audioUrl?.mp3}
            onTimeUpdate={handleTimeUpdate}
            onLoadedMetadata={handleLoadedMetadata}
            onCanPlay={handleCanPlay}
            onError={handleError}
            onEnded={handleEnded}
            preload='auto'
        />
        {isPlaying ? <PauseIcon
            style={{ color: '#B61256', cursor: 'pointer' }} fontSize='large'
            onClick={togglePlay}
        /> :
            <PlayIcon style={{ color: '#B61256', cursor: 'pointer' }} fontSize='large'
                onClick={togglePlay}
            />
        }
        <Slider
            disabled={!duration || isLoading}
            value={currentTime}
            min={0}
            max={typeof duration === 'number' && duration > 0 ? duration : 10}
            style={{ width: 400, margin: 5, marginLeft: 10 }}
            onChange={handleSeek}
        />
        <Typography style={{
            fontFamily: "Sofia",
            fontSize: 14,
            margin: 7,
        }}>{formatTime(duration)}</Typography>
        {
            audioUrl?.mp3 ? downloadStarted ? <CircularProgress style={{ color: '#B61256' }} size={20} /> : <CloudDownloadIcon
                style={{ marginTop: 5, color: '#B61256', cursor: 'pointer' }}
                onClick={handleDownload}
            /> : null
        }
    </Grid>)
}